export default __webpack_public_path__ + "static/media/gasag_background_xl1.203443e9.jpg";